import {
  IExercise,
  ILesson,
  ISection,
  IUserScheduled,
  TIME_HOURS_LS,
  TIME_MINUTE_LS,
} from "../type";

export function isCompletedLesson(exercises: IExercise[]) {
  if (!exercises || exercises.length === 0) return false;
  let completed = true;
  for (let i = 0; i < exercises.length; i++) {
    const ex = exercises[i];
    // Проверяем, есть ли запись о выполнении задания
    if (!ex.UserComplete_ExercisesRelation || ex.UserComplete_ExercisesRelation.length === 0) {
      completed = false;
      break; // Прерываем цикл, если нашли невыполненное задание
    }
  }
  return completed;
}

export function calculateComplitedLesson(section: ISection, round: number, allSections?: ISection[]) {
  let lockedSection = false;
  let today = new Date();
  const shed = section.UserLessonsScheduled.find(
    (sh) => sh.round === round
  ) as IUserScheduled;
  
  // Если нет расписания для этого круга - модуль заблокирован
  if (!shed) {
    return { complitedLesson: 0, lockedSection: false };
  }
  
  // Проверяем, пройден ли модуль (все уроки выполнены)
  const lessons = section.Lesson_SectionRelation.filter(
    (l) => l.round === shed.round
  );
  const complitedLesson = lessons.filter((l) =>
    isCompletedLesson(l.Exercise_LessonRelation)
  ).length;
  const allLessonsCompleted = lessons.length > 0 && complitedLesson === lessons.length;
  
  // Логирование для диагностики
  console.log(`[calculateComplitedLesson] Section ${section.id}, Round ${round}:`, {
    totalLessons: lessons.length,
    completedLessons: complitedLesson,
    allLessonsCompleted,
    lockedSection: allLessonsCompleted ? true : undefined
  });
  
  // Если модуль уже пройден - доступ открыт всегда (можно зайти в любое время на протяжении круга)
  if (allLessonsCompleted) {
    return { complitedLesson, lockedSection: true };
  }
  
  // Если модуль не пройден - проверяем только дату начала
  // Нельзя войти в модуль, который не подошел по расписанию (нельзя раньше срока)
  let targetDate = new Date(shed.start_date);
  var h = today.getTimezoneOffset() / 60;
  targetDate.setUTCHours(TIME_HOURS_LS + h, TIME_MINUTE_LS, 0, 0);
  
  // Если дата начала еще не наступила - модуль заблокирован
  if (targetDate > today) {
    lockedSection = false;
  } else {
    // Дата начала наступила - доступ открыт (не проверяем последовательность)
    lockedSection = true;
  }
  
  const daysDifference = Math.floor(
    Math.abs((today.getTime() - targetDate.getTime()) / (1000 * 3600 * 24))
  );
  if (daysDifference > 6) return { complitedLesson: 7, lockedSection };
  
  return { complitedLesson, lockedSection };
}

export function getCurrentSection(sections: ISection[]): ISection {
  const shed = getCurrentScheduled(sections);
  return sections.find((s) => s.id === shed.SectionId) as ISection;
}

export function getCurrentScheduled(sections: ISection[]): IUserScheduled {
  const today = new Date();
  const all_sched: IUserScheduled[] = [];
  sections.forEach((s) => {
    s.UserLessonsScheduled.forEach((u) => {
      all_sched.push(u);
    });
  });
  all_sched.sort((a, b) => +new Date(a.start_date) - +new Date(b.start_date));
  for (let i = 0; i < all_sched.length; i++) {
    const date = new Date(all_sched[i].start_date);
    var h = today.getTimezoneOffset() / 60;
    date.setUTCHours(TIME_HOURS_LS + h, TIME_MINUTE_LS, 0, 0);
    if (+date > +today) {
      return all_sched[i - 1];
    }
  }
  return all_sched[all_sched.length - 1];
}

export function prewiusScheduled(
  sections: ISection[]
): IUserScheduled | undefined {
  const today = new Date();
  const all_sched: IUserScheduled[] = [];
  sections.forEach((s) => {
    s.UserLessonsScheduled.forEach((u) => {
      all_sched.push(u);
    });
  });
  all_sched.sort((a, b) => +new Date(a.start_date) - +new Date(b.start_date));
  for (let i = 0; i < all_sched.length; i++) {
    const date = new Date(all_sched[i].start_date);
    var h = today.getTimezoneOffset() / 60;
    date.setUTCHours(TIME_HOURS_LS + h, TIME_MINUTE_LS, 0, 0);
    if (+date > +today) {
      if (i < 2) {
        return;
      }
      return all_sched[i - 2];
    }
  }
  return all_sched[all_sched.length - 2];
}

export function getTodayLesson(sections: ISection[]): ILesson {
  const currentSection = getCurrentSection(sections); //активный раздел курса
  const currentShed = getCurrentScheduled(sections); //текущее расписание для этого раздела

  const round = currentShed.round; //текущий round
  const today = new Date(); //текущая дата и время
  const targetDate = new Date(currentShed.start_date); //дата начала прохождения круга
  var h = today.getTimezoneOffset() / 60;
  targetDate.setUTCHours(TIME_HOURS_LS + h, TIME_MINUTE_LS, 0, 0); //время начала занятий

  //разница между текущей датой и датой начала в днях.
  // getTime() возвращает timestamp в миллисекундах.
  // (1000 * 3600 * 24) преобразует миллисекунды в дни.
  const daysDifference = Math.floor(
    Math.abs((today.getTime() - targetDate.getTime()) / (1000 * 3600 * 24))
  );

  console.log(
    "2",
    "daysDifference",
    daysDifference,
    "today",
    today,
    "targetDate",
    targetDate
  );

  const lessons = currentSection.Lesson_SectionRelation.filter(
    (l) => l.round === round
  );
  lessons.sort((a, b) => a.sequence_number__lesson - b.sequence_number__lesson);

  return lessons[daysDifference];
}

export function hasGold(section: ISection): boolean {
  const achiv = [];
  for (let i = 0; i < section.UserLessonsScheduled.length; i++) {
    const shed = section.UserLessonsScheduled[i];
    for (let j = 0; j < shed.AchievementsRelation.length; j++) {
      achiv.push(shed.AchievementsRelation[j]);
    }
  }
  for (let i = 0; i < achiv.length; i++) {
    if (achiv[i].typeAchievements === "Gold") {
      return true;
    }
  }
  return false;
}

export function hasPearl(section: ISection): boolean {
  const achiv = [];
  for (let i = 0; i < section.UserLessonsScheduled.length; i++) {
    const shed = section.UserLessonsScheduled[i];
    for (let j = 0; j < shed.AchievementsRelation.length; j++) {
      achiv.push(shed.AchievementsRelation[j]);
    }
  }
  for (let i = 0; i < achiv.length; i++) {
    if (achiv[i].typeAchievements === "Pearl") {
      return true;
    }
  }
  return false;
}
